import React from 'react'
import {
  IonSlides,
  IonSlide
} from '@ionic/react'
import { ChapterCard } from '../../../components/common/ChapterCard'
import PodcastChapterCard from '../../../components/common/PodcastChapterCard'
import { Advertisement } from '../../../components/common/Advertisement'
import './styles.scss'

const WatchFooter = (props) => {
  const { related } = props

  console.info('related', related)

  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 'auto',
    preventClicks: true,
    speed: 400
  }

  return (
    <section className='watch-footer'>

      <Advertisement />

      {related?.relatedType === 'nextChapter' &&
        <section className='related-content nextChapter'>
          <h1 className='related-title'>
            Ver siguiente:
          </h1>
          {related?.related[0]?.section_alias !== 'podcast' && <ChapterCard chapter={related.related[0]} />}
          {related?.related[0]?.section_alias === 'podcast' && <PodcastChapterCard chapter={related.related[0]} />}
        </section>}

      {related?.relatedType === 'cardGallery' &&
        <section className='related-content cardGallery'>
          <div>
            <h1 className='related-title'>Tal vez te pueda interesar</h1>
          </div>

          {related.related.length > 0 &&
            <IonSlides pager options={slideOpts}>
              {related.related.map((chapter) => (
                <IonSlide key={chapter.id}>
                  {chapter?.section_alias !== 'podcast' && <ChapterCard chapter={chapter} />}
                  {chapter?.section_alias === 'podcast' && <PodcastChapterCard chapter={chapter} />}
                  {/* <ChapterCard chapter={chapter} setTitle /> */}
                </IonSlide>
              ))}
            </IonSlides>}
        </section>}

    </section>
  )
}

export default WatchFooter
